import React from 'react';
import { inject, observer } from 'mobx-react';
import Alert from 'components/antd/Alert/Alert';
import { Form, InputNumber } from 'components/antd';
import { Fragment } from 'components';
import VehicleTab from './VehicleTab';
import VehicleOtherTab from './VehicleOtherTab';
import DriverNote from 'AppClient/components/DriverNote';

import styles from './styles.module.scss';

import {
	RootStore,
	BookingDictionariesStore,
	NewBookingsStore,
	PassengerDetailsStore,
} from 'AppClient/stores';

interface Props {
	bookingDictionariesStore?: BookingDictionariesStore;
	newBookingsStore?: NewBookingsStore;
	passengerDetailsStore?: PassengerDetailsStore;
}
class ChooseVehicleType extends React.Component<Props> {
	updateCarId = (id: number | string) => {
		const { pricesRequestPayload, updatePricesPayload } = this.props.newBookingsStore!;
		const { carTypeId } = pricesRequestPayload;
		updatePricesPayload({
			carTypeId: carTypeId === id ? null : id,
		});
	};

	render() {
		const { getDividedCars, passengersRatio } = this.props.bookingDictionariesStore!;
		const { pricesRequestPayload, updatePricesPayload } = this.props.newBookingsStore!;
		const { userInfo, updateJourneyNotes } = this.props.passengerDetailsStore!;
		const { carTypeId, numberOfPassengers } = pricesRequestPayload;
		const isTooManyPassengers = passengersRatio(carTypeId, numberOfPassengers);

		return (
			<Fragment>
				<div className="modalBoxRow dark">
					<div className="modalBoxCol">
						<Form.Item label="passengers">
							<InputNumber
								min={1}
								alignLeft
								value={numberOfPassengers || 1}
								defaultValue={1}
								onChange={value => {
									updatePricesPayload({
										numberOfPassengers: value || 0,
									});
								}}
							/>
							{isTooManyPassengers && <span className={styles.required}>*</span>}
						</Form.Item>
						{isTooManyPassengers && (
							<Alert
								type="error"
								message={`Selected vehicle type cannot 
								fit the number of passengers you have chosen.
								Please edit the number of passengers or vehicle type to proceed.`}
								showIcon
							/>
						)}
					</div>
				</div>
				<div className="modalBoxRow dark">
					<div className="modalBoxCol">
						<Form.Item label="choose vehicle type">
							<div className={styles.vehicles}>
								<div className={styles.vehiclesList}>
									{getDividedCars &&
										getDividedCars.carsTypes.map(carData => {
											return (
												<VehicleTab
													selectedId={carTypeId}
													key={carData.carTypeId}
													onSelect={this.updateCarId}
													carData={carData}
												/>
											);
										})}
									{getDividedCars && (
										<VehicleOtherTab
											carData={getDividedCars.otherCarsTypes}
											onSelect={this.updateCarId}
											selectedId={carTypeId}
										/>
									)}
								</div>
							</div>
						</Form.Item>
						{userInfo && (
							<DriverNote
								value={userInfo.journeyNotes}
								onChange={updateJourneyNotes}
							/>
						)}
					</div>
				</div>
			</Fragment>
		);
	}
}

export default inject(
	({
		bookingDictionariesStore,
		newBookingsStore,
		passengerDetailsStore,
	}: RootStore) => ({
		bookingDictionariesStore,
		newBookingsStore,
		passengerDetailsStore,
	})
)(observer(ChooseVehicleType));
